/* eslint-disable no-empty-pattern */
/* eslint no-param-reassign: 0 */
import { CollectionsService } from '../services/collections.service';

const collectionsState = {
  collections: [],
  collection: null,
  collectionItems: [],
  conf: {
    page: 1,
    per_page: 20,
    max_page: 1,
  },
  itemsConf: {
    direction: 'asc',
    sort: 'scheduled_start_time',
    page: 1,
    per_page: 20,
    max_page: 1,
  },
};
const mutations = {
  setList(state, collections) {
    state.collections = collections;
  },
  setCollection(state, collection) {
    state.collection = collection;
  },
  setConf(state, conf) {
    state.conf = conf;
  },
  setItems(state, items) {
    state.collectionItems = items;
  },
  setItemsConf(state, conf) {
    state.itemsConf = conf;
  },
};
const getters = {
  current: state => state.collection,
  list: state => state.collections,
  conf: state => state.conf,
  itemsConf: state => state.itemsConf,
  pagination: state => ({ page: state.conf.page, per_page: state.conf.per_page, max_page: state.conf.max_page }),
  collectionItems: state => state.collectionItems,
  itemsPagination: state => ({ page: state.itemsConf.page, per_page: state.itemsConf.per_page, max_page: state.itemsConf.max_page }),
};
const actions = {
  updateConf: ({ commit, state }, options) => {
    const conf = Object.assign(JSON.parse(JSON.stringify(state.conf)), options);
    commit('setConf', conf);
  },
  updateItemsConf: ({ commit, state }, options) => {
    const conf = Object.assign(JSON.parse(JSON.stringify(state.itemsConf)), options);
    commit('setItemsConf', conf);
  },
  delete: async ({}, id) => {
    try {
      await CollectionsService.deleteCollection(id);
      return true;
    } catch (e) {
      return false;
    }
  },
  getCollection: async ({ commit }, id) => {
    try {
      const collection = await CollectionsService.getCollection(id);
      commit('setCollection', collection);
      return collection;
    } catch (e) {
      return false;
    }
  },
  create: async ({}, payload) => {
    try {
      const collectionId = await CollectionsService.createCollection(payload);
      return collectionId;
    } catch (e) {
      return false;
    }
  },
  update: async ({ commit }, { id, ...payload }) => {
    try {
      const collection = await CollectionsService.updateCollection(id, payload);
      commit('setCollection', collection);
      return true;
    } catch (e) {
      return false;
    }
  },
  poster: async ({}, { id, file }) => {
    try {
      const poster = await CollectionsService.uploadPoster(id, file);
      return poster;
    } catch (e) {
      return false;
    }
  },
  getCollectionItems: async ({ commit, state, dispatch }, tags) => {
    const payload = JSON.parse(JSON.stringify(state.itemsConf));
    payload.tags = tags ? tags.join(',') : [];

    try {
      const items = await CollectionsService.getCollectionItems(payload);
      commit('setItems', items.items);
      dispatch('updateItemsConf', { page: items.pagination.current_page, max_page: items.pagination.max_page });
      return true;
    } catch (e) {
      return false;
    }
  },
  getBroadcastCollections: async ({}, tags) => {
    if (!tags) return [];
    const payload = {
      page: 1,
      per_page: 100,
      tags: tags.join(','),
    };
    try {
      const collections = await CollectionsService.getCollections(payload);
      return collections.collections;
    } catch (e) {
      return [];
    }
  },
  getCollections: async ({ commit, state, dispatch }) => {
    const payload = JSON.parse(JSON.stringify(state.conf));

    try {
      const collections = await CollectionsService.getCollections(payload);
      commit('setList', collections.collections);
      dispatch('updateConf', { page: collections.pagination.current_page, max_page: collections.pagination.max_page });
      return true;
    } catch (e) {
      return false;
    }
  },
  unset: ({ commit }) => {
    commit('setCollection', null);
    commit('setItems', []);
  },
};

export default {
  namespaced: true,
  state: collectionsState,
  mutations,
  getters,
  actions,
};
